const IP = process.env.REACT_APP_API_URL;
export default IP;
